import { getFileTypeIconProps, IFileTypeIconOptions } from '@uifabric/file-type-icons/lib/index';
import { IIconProps } from 'office-ui-fabric-react/lib/Icon';
import * as CommandsStyles from './Commands.scss';

/**
 * @internal
 */
export function getCommandIconProps(options: IFileTypeIconOptions): IIconProps {
  return {
    ...getFileTypeIconProps(options),
    className: CommandsStyles.newDocumentCommandIcon
  };
}
